import React, { useState } from 'react';
import GeneralModal from '../../../../components/GeneralModal/GeneralModal';
import { useEquipmentDecommissionMutation    } from '../../../../store/builder/inspections.api';
import { toast } from 'react-toastify';
import { useTranslation } from '../../../../hooks/useTranslation';
import './DecommissionEquipmentModal.scss';
const DecommissionEquipmentModal = ({ equipment, setIsOpen, getEquipmentsInitial }) => {
    const [decommissionEquipment, { isLoading: decommissionEquipmentIsLoading }] = useEquipmentDecommissionMutation();
    const {t} = useTranslation();
    const [reason, setReason] = useState('');
    
    const handleDecommission = () => {
        decommissionEquipment({ id: equipment?.id, reason }).then((res) => {
            if (res?.data?.message) {
                toast.success(res?.data?.message);
            }
            if (res?.error) {
                toast.error(res?.error?.data?.message);
            }
            setIsOpen(false);
            getEquipmentsInitial();
        });
    }
  return (
    <GeneralModal
      title={t('equipmentTable.modals.decommission.title')}
      onClose={() => setIsOpen(false)}
      onSubmit={handleDecommission}
      submitTitle={t('equipmentTable.actions.decommission')}
      btnType='delete'
      disableSubmit={reason.length < 10}
    >
      <div className='decommission-modal__content-body'>
        <p className='decommission-modal__message'>
          {t('equipmentTable.messages.decommissionEquipment')}
        </p>
        
        <div className='decommission-modal__input-group'>
          <label className='decommission-modal__label'>
            {t('equipmentTable.modals.decommission.reasonLabel')}
            <span className='required-asterisk'>*</span>
          </label>
          
          <textarea
            className={`decommission-modal__textarea ${reason.length > 0 && reason.length < 10 ? 'error' : ''}`}
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            placeholder={t('equipmentTable.modals.decommission.reasonPlaceholder')}
            rows={4}
            minLength={10}
            required
          />
          
          {reason.length > 0 && (
            <div className={`decommission-modal__character-count ${
              reason.length < 10 ? 'error' : 
              reason.length > 200 ? 'warning' : ''
            }`}>
              {reason.length}/500 characters
            </div>
          )}
          
          {reason.length > 0 && reason.length < 10 && (
            <div className='decommission-modal__error-message'>
              {t('equipmentTable.modals.decommission.minLengthMessage', { min: 10 })}
            </div>
          )}
        </div>
      </div>
    </GeneralModal>
  );
};

export default DecommissionEquipmentModal;